import { FunctionComponent } from "react";
import Bluetable from "./bluetable";
import Darkfan from "./darkfan";
import Greenshrimp from "./greenshrimp";
import Greycheerzou from "./greycheerzou";
import Redmug from "./redmug";

export type FilterComponent = FunctionComponent<{
  id: string;
  height: number;
  width: number;
}>;

export type FilterTag =
  | "bluetable"
  | "darkfan"
  | "greenshrimp"
  | "greycheerzou"
  | "none"
  | "redmug";

export const ORDERED_FILTER_TAGS: FilterTag[] = [
  "none",
  "redmug",
  "darkfan",
  "bluetable",
  "greenshrimp",
  "greycheerzou",
];

export class UnsupportedFilterTagError extends Error {
  constructor(value: string) {
    super(`Unsupported FilterTag "${value}"`);
  }
}

export function convertFilterTagFromFormat(filterTag: string): FilterTag {
  switch (filterTag) {
    case "bluetable":
    case "darkfan":
    case "greenshrimp":
    case "greycheerzou":
    case "none":
    case "redmug":
      return filterTag;
    default:
      throw new UnsupportedFilterTagError(filterTag);
  }
}

export function filterTagToSVGComponent(filterTag: FilterTag): FilterComponent | null {
  switch (filterTag) {
    case "bluetable":
      return Bluetable;
    case "darkfan":
      return Darkfan;
    case "greenshrimp":
      return Greenshrimp;
    case "greycheerzou":
      return Greycheerzou;
    case "none":
      return null;
    case "redmug":
      return Redmug;
    default: {
      const exhaustiveCheck: never = filterTag;
      throw new UnsupportedFilterTagError(exhaustiveCheck);
    }
  }
}

/*
 * Interesting doc:
 *
 * - https://stackoverflow.com/questions/53145883/how-to-use-a-simple-svg-filter-on-safari-with-acceptable-performance-and-without
 */
